import { PricingEngineType } from "../../types/pricing-engine"

/**
 * LO-level credential fields for each pricing engine.
 * These fields are stored at the top level of each lo_map entry (not in defaults/raw_defaults).
 */
export const ENGINE_LO_CREDENTIAL_FIELDS: Record<
  PricingEngineType,
  { key: string; label: string }[]
> = {
  optimal_blue: [
    { key: "biz_channel", label: "Business Channel" },
    { key: "originator_id", label: "Originator ID" }
  ],
  loan_sifter: [
    { key: "user_id", label: "User ID" },
    { key: "company_id", label: "Company ID" }
  ],
  lender_price: [
    { key: "user_id", label: "User ID" },
    { key: "company_id", label: "Company ID" }
  ],
  mortech: [
    { key: "customer_id", label: "Customer ID" },
    { key: "email", label: "Email" }
  ],
  polly: [],
  loanpass: [],
  mortgage_bot: []
}
